import { axiosInterceptors } from './axios-interceptor';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

const useAxios = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const axiosErrorHandler = useCallback(
    (err) => {
      const errormessage = err?.response?.data?.message || err.message || err;

      if (err.response?.status === 401 || err.status === 401) {
        history.push('/login');
        throw new Error('You are not authorized. Please login again.');
      }
      throw new Error(errormessage);
    },
    [history],
  );

  const axiosHttp = useCallback(
    async (url, options) => {
      setLoading(true);

      const { method = 'get', payload, params } = options ?? {};

      const axiosMethod =
        method === 'post'
          ? axiosInterceptors.post(url, { ...payload })
          : axiosInterceptors.get(url, { params });

      try {
        const result = await axiosMethod;
        return result;
      } catch (err) {
        return axiosErrorHandler(err);
      } finally {
        setLoading(false);
      }
    },
    [axiosErrorHandler],
  );

  return { loading, axiosHttp };
};

export { useAxios };
